export const LANG_MAP: Record<string, string> = {
  hy: 'hy-am'
};

export const LANG_MAP_REVERSED: Record<string, string> = {
  hy: 'hy',
  'hy-am': 'hy',
  en: 'en',
  'en-us': 'en',
  'ru-ru': 'ru'
};
